const MB = 1024 * 1024;
const GB = 1024 * MB;

export function formatBytes(bytes: number, locale: string): string {
  const gb = bytes >= GB;
  const value = bytes / (gb ? GB : MB);
  const number = new Intl.NumberFormat(locale, { maximumFractionDigits: gb || value < 10 ? 1 : 0 }).format(value);
  return `${number} ${gb ? 'GB' : 'MB'}`;
}
